import React, {useState} from 'react'
import {Modal, Form, Button, ButtonGroup} from 'react-bootstrap';
import {editProfilePicture, editProfileInfo} from "../../firebase/authorUtils";

export default function EditModal(props) {
  const [bio, setBio] = useState('');
  const [website, setWebsite] = useState('');
  const [location, setLocation] = useState('');
  const [file, setFile] = useState(null);
  const [invalid, setInvalid] = useState(false)

  const cleanup = () => {
    setBio(''); setWebsite(''); setLocation(''); 
    setInvalid(null); setFile(null); props.setOpen(false);
  }

  const updateBio = (e) => {
    const newBio = e.target.value;
    if (newBio.length <= 250) setBio(newBio);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let localError = false;
    if (website) {
      if (website.includes('http://') || website.includes('https://')) {
        setInvalid(false);
      } else if (!website.includes('http://') && !website.includes('https://')) {
        setInvalid(true); localError = true;
      }
    } else setInvalid(false);

    if (!localError) {
      if (bio || website || location) editProfileInfo({authorID: props.authorID, bio, website, location, setResult: props.setNotification});
      if (file) editProfilePicture({authorID: props.authorID, file, setResult: props.setNotification});
      cleanup();
    }
  }

  return (
    <div>
      <Modal
      show={props.open}
      size="lg"
      onHide={() => cleanup()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit your Profile Page
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="font-weight-bold">Bio ({bio.length + '/250'})</Form.Label>
              <Form.Control 
                required 
                type="text"
                placeholder="Quickly describe yourself..." 
                value={bio} 
                onChange={updateBio}
                />
            </Form.Group>

            <Form.Group controlId="formTextArea" className="mt-4">
              <Form.Label className="font-weight-bold">Location ({location.length + '/100'})</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Ex. Toronto, Ontario, Canada..."
                value={location}
                onChange={(e) => {if (e.target.value.length <= 100) setLocation(e.target.value)}}
                />
            </Form.Group>

            <Form.Group controlId="formTextArea" className="mt-4">
              <Form.Label className="font-weight-bold">How can others get in touch?</Form.Label>
              <Form.Control 
                type="text" 
                isInvalid={invalid}
                placeholder="Enter a website url (like Linkedin, Twitter, Facebook, etc.)..."
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                />
              <Form.Control.Feedback type="invalid">
                  Make sure website url has http:// or https:// Ex. https://www.example.com
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formTextArea" className="mt-4">
              <Form.Label className="font-weight-bold">Upload a Profile Picture</Form.Label>
              <Form.Control 
                type="file" 
                onChange={(e) => setFile(e.target.files[0])}
                />
            </Form.Group>

            <ButtonGroup className="d-flex mt-5">
              <Button block variant="success" onClick={handleSubmit}>Submit</Button>
            </ButtonGroup>
      
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}